import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/auth-context";
import { PersonaLoader } from "@/components/shared/persona-loader";
import { useProject } from "@/contexts/project-context";

interface ProtectedRouteProps {
  requiredRoles?: readonly string[];
}

export function ProtectedRoute({ requiredRoles }: ProtectedRouteProps) {
  const { user, isAuthenticated, isLoading } = useAuth();
  const { isLoading: isProjectLoading } = useProject();
  const hasRequiredRole =
    !requiredRoles?.length ||
    requiredRoles.some((requiredRole) =>
      user?.roles?.some((role) => role.id === requiredRole || role.name === requiredRole),
    );

  if (isLoading || (isAuthenticated && isProjectLoading)) {
    return <PersonaLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!hasRequiredRole) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
